import { Aspect } from '@teambit/harmony';

export const ReadmeAspect = Aspect.create({
  id: 'teambit.mdx/readme',
});
